/* Copyright (c) 2023 GRIP.S Medien GmbH & Co.KG */

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import ProjectsIcon from '@material-ui/icons/Apps';
import DashboardIcon from '@material-ui/icons/Dashboard';
import SettingsIcon from '@material-ui/icons/Settings';
import UsersIcon from '@material-ui/icons/SupervisedUserCircle';
import React from 'react';
import { NavLink } from 'react-router-dom';

const styles = (theme) => ({
  listItem: {
    paddingLeft: theme.spacing(3),
    color: theme.palette.text.primary,
  },
});

const mainItems = [
  {
    id: 'dashboard',
    icon: DashboardIcon,
    name: 'Startseite',
    link: '/',
    scopes: ['viewer', 'user', 'admin'],
  },
  {
    id: 'users',
    icon: UsersIcon,
    name: 'Benutzer',
    link: '/users',
    scopes: ['admin'],
  },
  {
    id: 'projects',
    icon: ProjectsIcon,
    name: 'Projekte',
    link: '/projects',
    scopes: ['viewer', 'user', 'admin'],
  },
  {
    id: 'settings',
    icon: SettingsIcon,
    name: 'Einstellungen',
    link: '/settings',
    scopes: ['admin'],
  },
];

const mainListItems = ({ classes, scopes }) => (
  <>
    {mainItems
      .filter((item) =>
        item.scopes.reduce(
          (hasAccess, scope) => hasAccess || scopes?.includes(scope),
          false,
        ),
      )
      .map(({ id, icon: Icon, name, link }) => (
        <NavLink to={link} activeClassName='active' key={`menu-item-${id}`}>
          <ListItem button className={classes.listItem}>
            <ListItemIcon>
              <Icon />
            </ListItemIcon>
            <ListItemText primary={name} />
          </ListItem>
        </NavLink>
      ))}
  </>
);

const mainList = withStyles(styles)(mainListItems);

export { mainList as default };
